import { type ActionItem, toastStore } from 'shared/ui'
import { writeTextToClipboard } from 'shared/lib'
import { uiStore } from 'shared/store/uiStore'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { ReviewActionsStore } from 'pages/reviews/store/reviewActionsStore'
import { ReviewsRoutes } from 'pages/reviews/route/type'

export const reviewActionsStore = new ReviewActionsStore()

export const getReviewActions = ({
  item,
  entities,
  onSuccessDelete,
  exportAction,
}: {
  item: { id: number; shortUrl: string }
  entities: IEntitiesStore
  onSuccessDelete?: () => void
  exportAction?: ActionItem
}): ActionItem[] => [
  {
    text: 'Edit',
    icon: 'edit',
    onAction: () =>
      uiStore.changeRouteViaVue({
        path: `/${ReviewsRoutes.root}/${ReviewsRoutes.edit}/${item.id}`,
      }),
  },
  ...(exportAction ? [exportAction] : []),
  {
    text: 'Copy link',
    icon: 'link',
    onAction: () => {
      writeTextToClipboard(item.shortUrl)
      toastStore.add({ type: 'info', title: 'Copied' })
    },
  },
  {
    text: 'Duplicate',
    icon: 'copy',
    onAction: () =>
      uiStore.changeRouteViaVue({
        path: `/${ReviewsRoutes.root}/${ReviewsRoutes.clone}/${item.id}`,
      }),
  },
  {
    text: 'Delete',
    icon: 'delete',
    onAction: () => reviewActionsStore.onDelete(item.id, entities, onSuccessDelete),
  },
]
